<template>
  <div>
    <OverlayPanel
      :ref="'op'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel" 
      style="width: 700px"
    >
      <Button style="float: left;" label="View Customer" icon="pi pi-search" @click="viewCustomer"/>
      <Button style="float: right;" label="View Full History" icon="pi pi-inbox" @click="viewFullHistory"/>
      <br />
      <br />
      <HistoryTable
        :data="customerHistory"
        :name="'Customer History'"
        :loading="customerHistoryLoading"
        :customer="tempCustomer"
      />
    </OverlayPanel>

    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 250px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="p-field p-col"
            v-for="(obj, index) in getActionButtons1()" 
            :key="index"
            style="margin: 0px; text-align: center; padding: 0px;"
          >
            <Button 
              :label="obj.label" 
              :icon="obj.icon"
              :disabled="obj.disabled ? obj.disabled : false"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
            />
          </div>
        </div>
        <hr />
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button 
              v-for="(obj, index) in actionButtons2" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <DataTable
      :key="tableKey"
      :value="activities"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      dataKey="activityId"
      :rowHover="true"
      :selection.sync="selectedActivities"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      :currentPageReportTemplate="'{first} to {last} of {totalRecords} ' + (recordsLabel || 'Activities')"
      :resizableColumns="true" 
      columnResizeMode="expand"
      @column-resize-end="colsResized"
      :reorderableColumns="false" 
      @column-reorder="colReordered"
      @page="onPage($event)"
      :lazy="true"
      :totalRecords="totalRecords"
      @sort="onSort($event)"
      :sortField="defaultSortField"
      :sortOrder="defaultSortOrder"
      :first="defaultFirstPage"
      :rows="defaultRows"
      @row-click="rowClicked($event)"
      contextMenu
      :contextMenuSelection.sync="selectedRow"
      @row-contextmenu="onRowContextMenu"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
    >
      <template #empty> No activities found. </template>
      <template #loading> Loading activities data. Please wait. </template>
      <div
        :key="columnsKey"
      >
        <!-- <Column selectionMode="multiple" headerStyle="width: 3em"></Column> -->
        <Column 
          header="Actions"
          headerStyle="width: 50px; height: 30px; padding: 10px 0px;"
          :frozen="true"
        >
          <template #body="slotProps">
            <div  
              style="height: 40px; padding: 10px 0px; display: flex; align-items: center;"
            >
              <Button 
                icon="pi pi-ellipsis-v" 
                class="p-button-rounded p-button-text"
                @click="toggleActions($event, slotProps.data)"
              />
            </div>
          </template>
        </Column>
        <Column 
          v-for="(col, index) of colSelectedFieldsForTable" 
          :key="col.dbField + '_' + index"
          :field="getOptionLabel(col)[0]" 
          :sortField="col.dbField.split('.').slice(-1)[0]"
          :header="col.fieldName" 
          :sortable="true"
          :headerStyle="'width: ' + col.defWidth + 'px; height: 41px;'"
        >
          <template #body="slotProps">
            <div
              style="height: 40px; padding: 10px 0px;"
              @click="openOP(slotProps.data, col, $event)"
              :class="getStyle1(slotProps.data, col)"
            >
              {{ getToShow(slotProps.data, col) }}
            </div>
          </template>
        </Column>
        <Column 
          field="statusName" 
          headerStyle="width: 9em;" 
          header="Status" 
          :sortable="true"
        >
          <template #body="slotProps">
            <span 
              v-on:click="changeStatus(slotProps.data)"
              :class="'ignore pointer badge ' + getStyle(slotProps.data)" 
            >
              {{ getStatusObj(slotProps.data) ? getStatusObj(slotProps.data)['statusName'] : '' }}
            </span>
                  
            <OverlayPanel 
              ref="statuses" 
              appendTo="body" 
              :showCloseIcon="true" 
              id="statuses" 
              style="width: 130px"
            > 
              <div
                v-for="(val, index) in tempActivityStatuses"
                :key="index"
              >
                <span 
                  @click="updateStatus(val)" 
                  :class="'ignore pointer badge ' + getStyle2(val)" 
                >
                  {{ val.statusName }}
                </span>
                <br />
                <br />
              </div>
            </OverlayPanel>
            <!-- <span :class="'customer-badge status-' + getStyle(slotProps.data.activityStatus.statusName)" style="font-size: 18px;">{{ slotProps.data.activityStatus.statusName }}</span> -->
            <!-- <span :class="'product-badge status-INSTOCK'" style="font-size: 18px;">{{ slotProps.data.activityStatus.statusName }}</span> -->
            <!-- <Badge value="slotProps.data.activityStatus.statusName" severity="danger"></Badge> -->
          </template>
        </Column>
        <!-- <Column 
          headerStyle="width: 10em;"
        >
          <template #body="slotProps">
            <div
              class="splitButtonColumn"
              :style="{position: 'absolute'}"
            >
              <SplitButton 
                label="View" 
                icon="pi pi-info" 
                @click="viewActivity(slotProps.data)" 
                :model="getButtons(slotProps.data)"
              >
              </SplitButton>
            </div>
          </template>
        </Column> -->
      </div>
    </DataTable>
    <ContextMenu :model="getButtons(selectedRow)" ref="cm" />

    <Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Are you sure you want to proceed?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text"/>
        <Button label="Yes" icon="pi pi-check" @click="confirmDeleteActivity" class="p-button-text" autofocus />
      </template>
    </Dialog>

    <ActivityMeetingDialog
      :meetingDialog="meetingDialog"
      :reload="reloadMeetingDialog"
      :activity="activity"
      :sendingRequest="sendingRequest"
      @close="meetingDialog = false"
      @save="saveMeetingDetails"
    />

    <ActivityRescheduleDialog
      :scheduleDialog="scheduleDialog"
      :reload="reloadScheduleDialog"
      :activity="activity"
      :sendingRequest="sendingRequest"
      :task="kindOfRecord(activity) === 'TASK'"
      @close="scheduleDialog = false"
      @save="saveScheduleDetails"
    />

    <CommentBox
      :reload="reloadCommentBox"
      :commentDialog="commentDialog"
      label="Please give details below"
      :sendingRequest="sendingRequest"
      @close="commentDialog = false"
      @save="addComment"
    />

  </div>
</template>
<script>
import { formatCurrency } from '@/utils/money'
import ActivityService from "@/service/ActivityService"
import FiltersService from "@/service/FiltersSerice"
import CustomerService from "@/service/CustomerService"

import ActivityMeetingDialog from '../activity/ActivityMeetingDialog'
import ActivityRescheduleDialog from '../activity/ActivityRescheduleDialog'
import CommentBox from '@/mbp/universalComponents/quotation/CommentBox'
import HistoryTable from '@/mbp/universalComponents/customer/customerHistoryTable'

// import Badge from 'primevue/badge';

import {
  activityRequest,
  columnSelectionRequest
} from '../sendRequest'
import { opensResultDialog, nextStatusesFor } from '../../activityCompletion.js'
import { kindOfRecord } from '../../activityKind.js'

export default {
  components: {
    ActivityMeetingDialog,
    ActivityRescheduleDialog,
    CommentBox,
    HistoryTable,
    // Badge
  },
  props: [
    "dbView",
    "activities", 
    "loading", 
    "colSelectedFieldsForTable", 
    "colSelectedFields", 
    "dbViewFields", 
    'totalRecords',
    'rows',
    'currentPage',
    'reloadTable',
    // Vuex module the list persists its sort and page to: the Activities list
    // and the Tasks list share this grid but not their state.
    'storeName',
    // What the pager counts ("1 to 3 of 3 Tasks"); Activities when not given.
    'recordsLabel'
  ],
  data: () => ({
    activityService: new ActivityService(),
    filtersService: new FiltersService(),
    customerService: new CustomerService(),
    selectedActivities: null,
    selectedRow: null,
    activitystatuses: [],
    activity: {},
    displayConfirmation: false,
    tempDelete: {},
    selected: [],
    tempActivityStatuses: [],
    meetingDialog: false,
    reloadMeetingDialog: 0,
    commentDialog: false,
    reloadCommentBox: 0,
    customerHistory: [],
    customerHistoryLoading: false,
    tempCustomer: {},

    previousPage: null,
    scheduleDialog: false,
    reloadScheduleDialog: 0,
    tableKey1: 0,
    columnsKey1: 0,
    defaultSortField: '',
    defaultSortOrder: 0,
    defaultFirstPage: 1,
    defaultRows: 25,
    sendingRequest: false,

    actionButtons2: [
      {
        label: 'History',
        icon: 'pi pi-inbox',
        command: (that) => {
          that.viewHistory(that.selectedRow)
        }
      }
    ]
  }),
  created() {
    
    this.setupComponent()
    
    this.activityService
      .getAllActiveActivityStatuses()
      .then((data) => (this.activitystatuses = data))
      .catch(err => {
        
              
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting activity statuses",
        //   life: 5000,
        // })
        this.$store.dispatch('addErrorMessage', {
          severity: 'error',
          content: 'Some data was not loaded from "activeActivityStatuses"'
        })
      })
  },
  mounted() {
    setTimeout(() => {
      this.setSplitButtonLocations()
    }, 100)
  },
  updated() {
    setTimeout(() => {
      this.setSplitButtonLocations()
    }, 100)
  },
  computed: {
    splitButtonLocationReset() {
      return this.$store.getters.getSplitButtonLocationReset
    },
    tableKey: {
      set(val) {
        this.tableKey1++
      }, 
      get() {
        return 'tableKey-' + this.tableKey1.toString()
      }
    },
    columnsKey: {
      set(val) {
        this.columnsKey1++
      }, 
      get() {
        return 'columnKey-' + this.columnsKey1.toString()
      }
    }
  },
  watch: {
    selectedRow(val) {
      
      if (this.selectedRow.activityStatusId && !this.selectedRow.activityStatus) {
        this.selectedRow.activityStatus = {
          statusName: this.selectedRow.activityStatusName,
          id: this.selectedRow.activityStatusId
        }
      }

      if (this.selectedRow.forUserId && !this.selectedRow.user) {
        this.selectedRow.user = {
          fullName: this.selectedRow.forUser,
          id: this.selectedRow.forUserId
        }
      }

      if (this.selectedRow.activityTypeId && !this.selectedRow.activityType) {
        this.selectedRow.activityType = {
          activityTypeName: this.selectedRow.activityTypeName,
          id: this.selectedRow.activityTypeId
        }
      }

      if (this.selectedRow.branchId && !this.selectedRow.mbpBranch) {
        this.selectedRow.mbpBranch = {
          branchName: this.selectedRow.mbpBranchCode,
          id: this.selectedRow.branchId
        }
      }

      if (this.selectedRow.customerId && !this.selectedRow.customer) {
        this.selectedRow.customer = {
          custName: this.selectedRow.custName,
          customerId: this.selectedRow.customerId
        }
      }

      if (this.selectedRow.contactId && !this.selectedRow.contact) {
        this.selectedRow.contact = {
          contactName: this.selectedRow.contactName,
          contactId: this.selectedRow.contactId
        }
      }

      if (this.selectedRow.quoteVerId && !this.selectedRow.quote) {
        this.selectedRow.quote = {
          quoteVer: this.selectedRow.quoteNo + '-' + this.selectedRow.versionNo,
          quoteVerId: this.selectedRow.quoteVerId,
          productValue: this.selectedRow.productValue,
          quoteNo: this.selectedRow.quoteNo,
          quoteStatus: this.selectedRow.quoteStatus
        }
      }

      if (this.selectedRow.meetingNotes && !this.selectedRow.resultNotes) {
        this.selectedRow.resultNotes = this.selectedRow.meetingNotes
      }

      if (this.selectedRow.activityResultId && !this.selectedRow.activityResult) {
        this.selectedRow.activityResult = {
          resultDesc: this.selectedRow.activityResultDesc,
          id: this.selectedRow.activityResultId
        }
      }

      if (this.selectedRow.reminderFlag && !this.selectedRow.reminder) {
        this.selectedRow.reminder = this.selectedRow.reminderFlag
      }

      if (this.selectedRow.reminderTypeId && !this.selectedRow.reminderType) {
        this.selectedRow.reminderType = {
          reminderTypeName: this.selectedRow.reminderTypeName,
          id: this.selectedRow.reminderTypeId
        }
      }

      if (this.selectedRow.createdById && !val.createdBy) {
        this.selectedRow.createdBy = {
          fullName: this.selectedRow.createdBy,
          id: this.selectedRow.createdById
        }
      }

      if (val.updatedById && !val.updatedBy) {
        this.selectedRow.updatedBy = {
          fullName: val.updatedBy,
          id: val.updatedById
        }
      }

    },
    splitButtonLocationReset(val) {
      this.setSplitButtonLocations()
    },
    rows(val) {
      this.defaultRows = val
    },
    currentPage(val) {
      this.defaultFirstPage = (val - 1) * this.defaultRows
    },
    reloadTable(val) {
      
      this.setupComponent()

      this.tableKey++
    },
    activities(val) {
      this.columnsKey++
    },
    selected(val) {
      
      if (val && val[0] && val[0].id) {
        this.sendingRequest = false
        this.setSplitButtonLocations()
        columnSelectionRequest(this, 'ActivityTableForLazyLoadingWithResize.vue')
      }
    },
    colSelectedFieldsForTable(val) {

      this.columnsKey++
      // setTimeout(() => this.colSelectedFieldsForTable.forEach(a => 
    }
  },
  methods: {
    kindOfRecord,
    onRowContextMenu(event) {
      // this.$refs.cm.show(event.originalEvent);
    },
    rowClicked(event) {
      
      if (
        event 
        && event.originalEvent 
        && event.originalEvent.target 
        && (
          event.originalEvent.target.classList.contains("under_lined")
          ||
          event.originalEvent.target.classList.contains("ignore")
        )
      ) {
        return
      } else {
        this.selectedRow = event.data
        setTimeout(() => {
          this.viewActivity(this.selectedRow)
        }, 1)
      }
    },
    setSplitButtonLocations() {
      let a = document.getElementsByClassName('splitButtonColumn')
      // 
      if (a) {
        a.forEach(div => {
          // 
          div.style.top = (div.parentElement.offsetTop + 10).toString() + 'px'
          div.style.left = (div.parentElement.offsetLeft + 10).toString() + 'px'
        })
      }
    },
    setupComponent() {
      
      
      const storeName = this.storeName || 'myactivities'

      if (this.$store.getters[storeName + '/getSortField']) {
        this.defaultSortField = this.$store.getters[storeName + '/getSortField']
        this.defaultSortOrder = this.$store.getters[storeName + '/getSortOrder']
        
      } else {
        this.defaultSortField = ''
        this.defaultSortOrder = 0
      }

      this.defaultRows = this.$store.getters[storeName + '/getRows']
      this.defaultFirstPage = (this.$store.getters[storeName + '/getPage'] - 1) * this.defaultRows

    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    openOP(data, col, event) {
      
      if (data.customerId) {
        data.customer = {
          customerId: data.customerId,
          custName: data.custName
        }
      }
      
      if (data && data.customer && data.customer.customerId && event.target && event.target.className === "under_lined") {
        this.tempCustomer = data.customer
        this.customerHistory = []
        this.customerHistoryLoading = true
        this.customerService
          .getCustomerHistory(data.customer.customerId)
          .then(data => {
            if (data.length > 20) {
              this.customerHistory = data.slice(0, 20);
            } else {
              this.customerHistory = data
            }
            this.customerHistoryLoading = false
          })
          .catch(err => {
            this.customerHistoryLoading = false
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting customer history.",
            //   life: 5000,
            // })
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "getCustomerHistory/{customerId}"'
            })
          })
        this.toggle(event);
      }
    },
    viewFullHistory() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "/customers/" + this.tempCustomer.customerId + "/history",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    viewCustomer() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "/customers/" + this.tempCustomer.customerId + "/detail",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    getKey1() {
      
      return this.columnsKey + this.columnsKey.toString()
    },
    getKey() {
      
      return ''
    },
    colReordered(event) {
      
    },
    colsResized(event) {
      
      
      if (
        event.element && 
        event.element.clientWidth &&
        event.element.textContent
      ) {
        let e = event.element.clientWidth
        

        if (this.colSelectedFields && this.colSelectedFields[0]) {
          
          let a = this.colSelectedFields.find(b => b.dbField.fieldName === event.element.textContent)
          

          this.setSplitButtonLocations()
          if (a && a.id) {
            this.filtersService
              .setUserViewColWidth(a.id, e)
              .then(data => {
                this.setSplitButtonLocations()

                this.$emit('colUpdated', {
                  id: a.id,
                  width: parseInt(e)
                })
              })
              .catch(error => {
                
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: `Error while updating column width.`,
                  life: 5000,
                })
              })
          }
        }
      }
    },
    onSort(event) {
      // 
      this.colSelectedFieldsForTable.forEach(element => {
        let a = element.dbField.split('.')
        if (a[a.length - 1] === event.sortField) {
          

          this.$emit('sortChange', {
            sortField: event.sortField,
            sortFieldId: element.id,
            sortOrder: event.sortOrder
          })
        }
      })
    },
    onPage(event) {
      
      if (!(this.previousPage && event.page === this.previousPage.page && event.rows === this.previousPage.rows && event.pageCount === this.previousPage.totalpages)) {
        this.previousPage = {
          page: event.page + 1,
          rows: event.rows,
          totalPages: event.pageCount
        }
        this.$emit('lazyNext', this.previousPage)
      }
    },
    addComment(comment) {
      
      this.sendingRequest = true 
      
      this.activityService
        .updateActivityStatus(this.activity.activityId, {
          newStatusId: this.tempObj.id,
          resultNotes: comment,
        })
        .then(data => {
          this.sendingRequest = false
          this.commentDialog = false

          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Status updates.",
            life: 5000,
          })

          this.$emit('reload')
        })
        .catch(error => {
          this.sendingRequest = false
          this.commentDialog = false

          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while updating status.",
            life: 5000,
          })

        })
    },
    saveScheduleDetails(activity) {
      
      this.sendingRequest = true 

      this.activityService
        .updateActivityStatus(this.activity.activityId, {
          newStatusId: this.tempObj.id,
          NewStartDate: activity.startDate,
          NewStarTime: activity.startTime,
          NewDuration: activity.duration,
          NewEndDate: activity.endDate,
          NewEndTime: activity.endTime,
        })
        .then(data => {
          this.sendingRequest = false
          this.scheduleDialog = false

          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Status updates.",
            life: 5000,
          })

          this.$emit('reload')
        })
        .catch(error => {
          this.sendingRequest = false
          this.scheduleDialog = false

          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while updating status.",
            life: 5000,
          })
        })

    },
    saveMeetingDetails(activity) {
      this.sendingRequest = true 

      let obj = {}

      if (activity.activityType) {
        obj = {
          newStatusId: this.tempObj.id,
          resultId: activity.activityResult.id,
          resultNotes: activity.notes,
          NewActivityType: activity.activityType.id,
          NewSubject: activity.subject,
          NewStartDate: activity.startDate,
          NewStarTime: activity.startTime,
          NewDuration: activity.duration,
          NewEndDate: activity.endDate,
          NewEndTime: activity.endTime,
        }
      } else {
        obj = {
          newStatusId: this.tempObj.id,
          resultId: activity.activityResult.id,
          resultNotes: activity.notes
        }
      }

      this.activityService
        .updateActivityStatus(this.activity.activityId, obj)
        .then(data => {
          this.sendingRequest = false
          this.meetingDialog = false

          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Status updates.",
            life: 5000,
          })
          // The backend answers with the follow-up activity's id when it made one, and with an
          // empty body otherwise - a successful save either way, so the list always refreshes.
          if(activity.activityType && data > 0)
          {
            this.$emit('showActivity', data)
          }
          else
          {
            this.$emit('reload')
          }
        })
        .catch(error => {
          this.sendingRequest = false
          this.meetingDialog = false

          let index = -1, a = 'java.lang.RuntimeException: ';
          if (error && error.response && typeof error.response.data === 'string') {
            index = error.response.data.indexOf(a)
          }
          if (index < 0) {
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "v1/updateActivityStatus/{activityId}"'
            })
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error Message",
              detail: error.response.data.substr(index + a.length, error.response.data.length - 1),
              life: 5000,
            })
          }
        })

    },
    getOptionLabel(data){
      if (data) {
        if (data.dbNameField) {
          return [data.dbNameField]
        } else {
          return data ? data.dbField.split('.').slice(-1) : []
        }
      }
    },
    getStyle1(data, col) {
      if (
        col.dbField === 'quote.quoteVer' ||
        col.dbField === 'customer.custName' ||
        col.dbField === 'custName' 
      ) {
        return 'under_lined'
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getToShow(data, col) {
      let a = col.dbField.split('.')
      
      let b = ''
      if (a.length > 1) {
        b = data[a[0]] ? data[a[0]][a[1]] : ''
      } else {
        b = data[col.dbField]
      }

      if (col.fieldType === "Currency" && b !== null && b !== undefined) {
        return formatCurrency(b)
      } else if (col.dbField === "versionNo") { // Quote/Ver Title Col
          if (data["quoteNo"] && data["versionNo"]) return `${data["quoteNo"]}-${data["versionNo"]}`
          else if(data["quoteNo"]) return `${data["quoteNo"]}`
          else if(data["versionNo"]) return `${data["versionNo"]}`
      } else {
        return b
      }
    },
    viewHistory(data) {
      this.$router.push({
        path: "/activities/" + data.activityId + "/history",
        params: { activityId: data.activityId },
      });
    },
    runFunction(obj) {
      this.$refs.opActions.hide();
      obj.command(this)
    },
    toggleActions(event, data) {
      this.selectedRow = data
      this.$refs.opActions.toggle(event);
    },
    updateStatus(val) {

      if (this.activity && this.activity.activityId && val && val.id) {
        this.$refs.statuses.hide();
        this.sendingRequest = false
              
        if (this.activity.activityTypeName && this.activity.activityTypeId) {
          this.activity.activityType = {
            activityTypeName: this.activity.activityTypeName,
            activityTypeId: this.activity.activityTypeId,
          }
        }

        if (this.activity)
        
        if (opensResultDialog(val.statusName, this.activity.activityStatus.statusName)) {
          this.tempObj = val
          this.meetingDialog = true
          this.reloadMeetingDialog++

        } else if (val.statusName === 'Rescheduled') {
          this.tempObj = val
          this.scheduleDialog = true
          this.reloadScheduleDialog++

        } else if (val.statusName === 'Cancelled') {
          this.tempObj = val
          this.commentDialog = true
          this.reloadCommentBox++

        } else {
          this.activity.activityStatus = val
          this.sendingRequest = true
              
          
          this.activityService
            .updateActivityStatus(this.activity.activityId, {
              newStatusId: val.id
            })
            .then(data => {
              this.sendingRequest = false
              
              this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Status updates.",
                life: 5000,
              })

              this.$emit('reload')
            })
            .catch(error => {
              this.sendingRequest = false
              
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while updating status.",
                life: 5000,
              })
            })

        }
      }
    },
    changeStatus(d) {
      var activity = d
      activity.activityStatus = this.getStatusObj(d)
      

      if (!(activity.activityStatus.statusName === 'Completed' || activity.activityStatus.statusName === 'Cancelled') && this.activitystatuses) {

        this.tempActivityStatuses = nextStatusesFor(
          activity.activityStatus.statusName,
          this.activitystatuses
        )

        // 

        this.activity = {...activity}
        this.$refs.statuses.toggle(event);

      }
    },
    getStatusObj(d) {
      var data = null
      if (d) {
        if (d.activityStatus) {
          data = d.activityStatus
        } else if (d.activityStatusName) {
          data = {
            statusName: d.activityStatusName,
            id: d.activityStatusId,
            colourCode: d.colourCode,
            statusCode: d.statusCode,
            active: d.active
          }
        }
      }
      return data
    },
    getColorCode(data) {
      // https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data.colourCode) {
        return data.colourCode
      } else if (data.statusName && data.statusName.toLowerCase() === 'upcomming') {
        return 'badge-primary'
      } else if (data.statusName && data.statusName.toLowerCase() === 'task') {
        return 'badge-warning'
      } else if (data.statusName && data.statusName.toLowerCase() === 'overdue') {
        return 'badge-danger'
      } else if (data.statusName && data.statusName.toLowerCase() === 'completed') {
        return 'badge-success'
      } else {
        return 'badge-dark'
      }
    },
    getStyle2(d) {
      return this.getColorCode(d)
    },
    getStyle(d) {
      var data = this.getStatusObj(d)

      if (data && data.colourCode) {
      console.log(data)
      }

      if (!data) {
        return ''
      } else {
        return this.getColorCode(data)
      }
      // if (data && data.toLowerCase() === 'upcomming') {
      //   return 'NEW'
      // } else if (data && data.toLowerCase() === 'task') {
      //   return 'PROPOSAL'
      // } else if (data && data.toLowerCase() === 'overdue') {
      //   return 'UNQUALIFIED'
      // } else if (data && data.toLowerCase() === 'completed') {
      //   return 'QUALIFIED'
      // } else {
      //   return 'RENEWAL'
      // }
    },
    viewActivity(data) {
      var activity = data


      this.$store.dispatch('activities/setActivityForTabs', activity)

      // push, not replace: replacing overwrote the list's history entry, so Back skipped the list.
      this.$router.push({
        path: "/activities/" + activity.activityId + "/detail",
        params: { activityId: activity.activityId },
        // query: { activity: data }
      });
    },
    editActivity(activity) {
      
      if (!(activity.activityStatus.statusName === 'Completed' || activity.activityStatus.statusName === 'Cancelled')) {
        this.$emit("editActivity", activity);
      }
    },
    deleteActivity(data) {
      if (
        (
          data 
          && data.activityStatusName
          && data.activityStatusName !== 'Completed'
        )
        || 
        (
          data 
          && data.activityStatus
          && data.activityStatus.statusName
          && data.activityStatus.statusName !== 'Completed'
        )
      ) {
        this.tempDelete = data
        this.displayConfirmation = true
      }
    },
    confirmDeleteActivity() {
      this.displayConfirmation = false
      this.$emit("confirmDeleteActivity", this.tempDelete);
    },
    getButtons(data) {
      let buttons = []
      return buttons
    },
    getActionButtons1() {
      var buttons = [
        {
          label: 'View',
          icon: 'pi pi-info',
          command: (that) => {
            that.viewActivity(that.selectedRow)
          }
        },
        {
          label: 'Edit',
          icon: 'pi pi-pencil',
          command: (that) => {
            that.editActivity(that.selectedRow)
          }
        }
      ]
      
      if (
        (
          this.selectedRow 
          && this.selectedRow.activityStatusName
          && this.selectedRow.activityStatusName !== 'Completed'
        )
        || 
        (
          this.selectedRow 
          && this.selectedRow.activityStatus
          && this.selectedRow.activityStatus.statusName
          && this.selectedRow.activityStatus.statusName !== 'Completed'
        )
      ) {
        buttons.push({
          label: 'Delete',
          icon: 'pi pi-trash',
          command: (that) => {
            that.deleteActivity(that.selectedRow)
          }
        })
      }

      return buttons
    },
  },
};
</script>

<style scoped lang="scss">

</style>
